import React, { useState } from "react";
import classNames from "classnames";
import { Collapse } from "reactstrap";
import SideBarItem from "./SideBarItem";
const SubMenu = (props) => {
    const [collapsed, setCollapsed] = useState(true);
    const toggle = () => setCollapsed(!collapsed);
    const { icon, title, items } = props;

    return (
        <div>

            <SideBarItem text={title} icon={icon} onClick={toggle} submenu collapsed={collapsed} />


            <Collapse
                isOpen={!collapsed}
                navbar
                className={classNames("items-menu", { "mb-1": !collapsed })}
            >
                {items.map((item, index) => {

                    return (
                        <SideBarItem key={index} text={item.name} link={item.path} icon={item.icon} active={item.active} subItem />
                    )
                }
                )}
            </Collapse>
        </div>
    );
};

export default SubMenu;
